import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router';
import { Toolbar } from '@mui/material';
import LoginPersistence from '../../login/LoginPersistence';
import FeaturesLoader from '../../loaders/FeaturesLoader';
import { AUTH_LEVELS } from '../../auth/Authorized';
import AppHeader from './AppHeader';
import NavDrawer from './drawer/NavDrawer';
import Account from '../../account/Account';
import ApiAndDocs from '../../docs/ApiAndDocs';
import Dashboard from '../../dashboard/Dashboard';
import DataModelPage from '../../dataModel/DataModelPage';
import Staging from '../../staging/Staging';
import ExploreView from '../../explore/ExploreView';
import UserManagement from '../../userMgmt/UserManagement';
import BuildingManagement from '../../buildingMgmt/BuildingManagement';
import ActionLogAudit from '../../actionLog/ActionLogAudit';
import DEFAULT_NAV_ITEMS from '../constants';

import './portal.css';
import './grid.css';

const scrollTop = () => window.scrollTo(0, 0);
const { PORTAL_USER, ORG_ADMIN, SUPER_ADMIN } = AUTH_LEVELS;

const PortalBase = ({ auth, loginType, children, navItems = DEFAULT_NAV_ITEMS }) => {
  const Auth = auth;
  const LoginComponent = loginType;

  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AppHeader />
      <NavDrawer navItems={navItems} />
      <main className="content">
        <Toolbar /> {/* offsets the fixed top toolbar */}
        <Routes>
          {/*
           * Off limits due to conflicts in GCP hosting front-end and API through single endpoint
           * <Route path="/api" />
           */}
          <Route path="/login" element={<LoginComponent />} />
          <Route path="/account" element={<Auth child={Account} level={PORTAL_USER} />} />
          <Route path="/data-model" element={<Auth child={DataModelPage} level={PORTAL_USER} />} />
          <Route
            path="/data-model/*"
            element={<Auth child={DataModelPage} level={PORTAL_USER} />}
          />
          <Route path="/docs" element={<Auth child={ApiAndDocs} level={PORTAL_USER} />} />
          <Route path="/docs/:tab/*" element={<Auth child={ApiAndDocs} level={PORTAL_USER} />} />
          {/* Admin panel routes */}
          <Route
            path="/actions-audit"
            element={<Auth child={ActionLogAudit} level={SUPER_ADMIN} />}
          />
          <Route
            path="/building-edit"
            element={<Auth child={BuildingManagement} level={SUPER_ADMIN} />}
          />
          <Route
            path="/users"
            element={
              <Auth child={UserManagement} level={ORG_ADMIN} componentProps={{ scrollTop }} />
            }
          />
          <Route path="/dashboard" element={<Auth child={Dashboard} level={PORTAL_USER} />} />
          <Route path="/staging" element={<Auth child={Staging} level={PORTAL_USER} />} />
          <Route
            path="/staging/:bid/:view"
            element={<Auth child={Staging} level={PORTAL_USER} />}
          />

          <Route
            path="*"
            element={
              <Auth child={ExploreView} level={PORTAL_USER} componentProps={{ scrollTop }} />
            }
          />
          {children}
        </Routes>
      </main>
      <LoginPersistence />
      <FeaturesLoader />
    </BrowserRouter>
  );
};

export default PortalBase;
